import {initPhoneCountryFields as initStandardPhoneCountryFields} from "../../default/global/js/phoneCountryField";

// The standard preselects Germany unless the field says otherwise (data-countrycode). The company can maintain
// another country (feature PHONE_DEFAULT_COUNTRY), it arrives with the globals as defaultPhoneCountry.
//
// data-countrycode alone is not enough: intl-tel-input resets an empty field to its default country, which is the
// first of the preferred countries, and the standard does that right after the start. So the country goes in
// front of the preferred countries as well.
function applyDefaultPhoneCountry(inputPhones) {
    const country = typeof GLOBALS !== "undefined" ? GLOBALS.config.defaultPhoneCountry : null;
    if (!country) {
        return;
    }

    const iso2 = country.toLowerCase();
    GLOBALS.preferredPhoneCountries = [iso2, ...(GLOBALS.preferredPhoneCountries || []).filter((preferred) => preferred.toLowerCase() !== iso2)];

    for (const inputPhone of inputPhones) {
        if (inputPhone.dataset.countrycode === undefined) {
            inputPhone.dataset.countrycode = country;
        }
    }
}

export function initPhoneCountryFields(query = document.querySelectorAll(".js-phoneCountryField")) {
    applyDefaultPhoneCountry(query);
    initStandardPhoneCountryFields(query);
}
